import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {localesForLangDropdownQueryType} from "./__graphql-types__/index.ts";

export const LOCALES_QUERY: GqlOperation<
    localesForLangDropdownQueryType["response"],
    localesForLangDropdownQueryType["variables"]
> = gqlOp(gql`
    query localesForLangDropdownQuery {
        localesForLanguagePicker(includeEnglish: true, includeFake: false) {
            id
            localName
            kaLocale
        }
    }
`);
